const setCurrentBalanceValues = payload => ({
  type: "SET_CURRENT_BALANCE_VALUES",
  payload
});

const setTransactionDetailsValues = payload => ({
  type: "SET_TRANSACTION_DETAILS_VALUES",
  payload
});

export default {
  setCurrentBalanceValues,
  setTransactionDetailsValues
};
